import {FC} from 'react'

import {Text, TextFontWeight, TextVariant} from '@/components/common/content/Text'
import {getQuestionsAndAnswersContent} from '@/content/questionsAndAnswers'
import {Link, useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {
  QuestionsAndAnswersContentType,
  questionsAndAnswersContentTypeToRoute,
} from '@/utils/questions-and-answers/constants'
import {QuestionsAndAnswersCategoryItem} from '@/utils/questions-and-answers/types'
import {MOBILE_SCREENSIZE} from '@/utils/styles/breakpoints'

import {ContentWithInnerHTML} from '../common/content/ContentWithInnerHTML'

type QuestionsAndAnswersCategoryContentProps = {
  type: QuestionsAndAnswersContentType
  categorySlug: string
  description: string
  items: QuestionsAndAnswersCategoryItem[]
}

export const QuestionsAndAnswersCategoryContent: FC<QuestionsAndAnswersCategoryContentProps> = ({
  type,
  categorySlug,
  description,
  items,
}) => {
  const {t} = useTranslation()
  const {faqTitle} = getQuestionsAndAnswersContent(type)

  const faqItems = items.filter(({isFAQ}) => isFAQ)

  return (
    <>
      <ContentWithInnerHTML content={description} />
      {faqItems.length > 0 && (
        <div className="questions">
          <Text variant={TextVariant.h5} element="h2" fontWeight={TextFontWeight.bold}>
            {t(faqTitle)}
          </Text>
          <ul className="list">
            {faqItems.map(({name, slug}) => (
              <li key={slug} className="link">
                <Text variant={TextVariant.text20}>
                  <Link
                    href={questionsAndAnswersContentTypeToRoute[type].question(categorySlug, slug)}
                    legacyBehavior
                  >
                    <a className="underline">{name}</a>
                  </Link>
                </Text>
              </li>
            ))}
          </ul>
        </div>
      )}

      <style jsx>{`
        .questions {
          margin-top: ${theme.spacing[7]};
        }

        .list {
          margin-top: ${theme.spacing[5]};
          margin-left: ${theme.spacing[4]};
          list-style: inherit;
        }

        .link + .link {
          margin-top: ${theme.spacing[3]};
        }

        @media ${MOBILE_SCREENSIZE} {
          .questions {
            margin-top: ${theme.spacing[6]};
          }

          .list {
            margin-top: ${theme.spacing[4]};
            margin-left: ${theme.spacing[3]};
          }
        }
      `}</style>
    </>
  )
}
